import styled from "styled-components";

const ChartCustom = styled.div`
  width: calc(100% - 92px);

  padding: 0px 10px;
  height: 10px;

  position: absolute;
  bottom: 20px;

  display: flex;
  flex-flow: row;
  justify-content: space-between;

  opacity: 0.7;
`;

const BaseBox = styled.div`
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 3px;
  transition: width 1s linear;
`;

const Background = styled(BaseBox)`
  background: transparent;
  width: 100%;
`;

const Progress = styled(BaseBox)<{ percent: number; color: string }>`
  background: ${({ color }) => color};
  width: ${({ percent }) => percent}%;
`;

type ChartCustomXAxisProps = {
  color: string;
  percent: number;
};

export const ChartCustomXAxis = ({ percent, color }: ChartCustomXAxisProps) => {
  return (
    <ChartCustom>
      {/* <p>-20 sec</p>
      <p>-10 sec</p>
      <p style={{ marginLeft: "-25px" }}>Now</p>
      <p>+10 sec</p> */}
      <Background />
      <Progress percent={percent} color={color} />
    </ChartCustom>
  );
};
